module.exports = "https://r.nearpod.com/assets/media/image/question-icon-295dbb981483611aa953d523bc26d96b.svg";